module.exports = __webpack_public_path__ + "static/img/desktop_screen1.f2e5935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/desktop_screen1.jpg
// module id = WbEA
// module chunks = 2